// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__7njJD","rightAdornment":"Header_rightAdornment__1bU9S"};